import { getGraphqlClient } from "@/api/graphql/client.ts";

import { deleteTidLinkedAccountMutation } from "./mutations.ts";

export const deleteTidLinkedAccount = (id: string) => {
  const graphqlClient = getGraphqlClient();

  return graphqlClient.request(deleteTidLinkedAccountMutation, {
    id,
  });
};
